import md5 from "md5"
import axios from "axios"
import moment from "moment";
import router from "../router";

export default {
    namespaced: true,
    state: {
        user: null,
        addresses: null,
        pageAfter: null,
        notificationState: '',
        registredFormDef: {
            "base-first_name": "",
            "base-last_name": "",
            "base-email": "",
            "email_confirm": "",
            "base-phone": "",
            "base-zipcode": "",
            password: "",
            "base-birthday": "",
            terms: "",
            notifications: false,
        },
        registredForm: null
    },
    mutations: {
        setUser(state, val) {
            if (val && val.password) {
                delete val.password
            }
            state.user = val;
            window.localStorage.setItem("user", JSON.stringify(val));
        },
        getSavedUser(state) { //Get user from local storage
            const user = JSON.parse(window.localStorage.getItem("user"));
            if (user && user.member_id) {
                state.user = user;
                state.user.date_of_birth = state.user.date_of_birth ? moment(state.user.date_of_birth, 'YYYY/MM/DD/').format('MM/DD/yyyy') : null
                axios.defaults.headers["Auth-Token"] = user.auth_token;
            }
        },
        setRegistredForm(state, val) {
            state.registredForm = val;
        },
        setNotificationFlag(state, val) {
            state.notificationState = val;
        }
    },
    actions: {
        login(store, {username, password, callback}) {
            const usernamePasswordBuffer = Buffer.from(username + ':' + md5(password));
            const base64data = usernamePasswordBuffer.toString('base64');
            if (axios.defaults.headers["Auth-Token"]) {
                delete axios.defaults.headers["Auth-Token"];
            }
            axios.get("/auth/index", {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${base64data}`,
                    'Container-Type': `group`,
                    'Container-Id': store.rootState.shared.groupId,
                },
                params: {
                    'source' : window.cordova ? window.deviceVersion : ""
                }
            }).then(data => {
                const user = data.data;

                if (user && user.member_id && user.auth_token) {
                    axios.defaults.headers["Auth-Token"] = user.auth_token;
                    axios.get('/auth/users/' + user.member_id + '/profile').then(res => {
                        res.data.must_update_password = user.must_update_password;
                        store.commit("setUser", res.data);
                        if (callback) {
                            callback();
                        }
                    })
                }
            }).catch(error => {
                if (error.response && error.response.status === 403) {
                    store.commit("shared/setAlert", "Account is blocked", {root: true});
                } else if (error.response) {
                    store.commit("shared/setAlert", error.response.data, {root: true});
                } else {
                    store.commit("shared/setAlert", "Error", {root: true});
                }
            });
        },

        registerUser(store, {callback}) {
            let tempForm = store.state.registredForm;
            tempForm['base-birthday'] = store.state.registredForm['base-birthday'] ? moment(store.state.registredForm['base-birthday'], 'MM/dd/yyyy').format('MM/DD/YYYY') : null
            delete tempForm['email_confirm']
            axios.post(`/unauth/businesses/${store.rootState.shared.businessId}/members`, tempForm).then(res => {
                if (res.status === 200) {
                    if (callback) {
                        callback();
                    }
                }
            }).catch(res => {
                if (res.response) {
                    const error = res.response.data.errors;
                    store.commit("shared/setAlert", `<h5>${error[Object.keys(error)[0]]}</h5`, {root: true})
                } else {
                    store.commit("shared/setAlert", `<h5>Error. Please check your internet connection.</h5>`, {root: true})
                }
            });
        },

        logout(store) {
            store.commit("setUser", null);
            store.commit("cart/resetCart", null, {root: true});
            store.commit("giftcard/resetGcart", null, {root: true});
            window.localStorage.removeItem("user");
            delete axios.defaults.headers["Auth-Token"];
            router.push({name: 'Home'});
        },

        updateUserInformation(store, sval) {
            let val = {...sval};
            if (val.date_of_birth) {
                val.date_of_birth = moment(val.date_of_birth, 'MM/DD/YYYY').format('YYYY-MM-DD');
            }
            if (sval.email == store.state.user.email) {
                delete val.email;
            }
            if (sval.phone == store.state.user.phone) {
                delete val.phone;
            }


            axios.put(`/auth/users/${store.state.user.member_id}/profile`, val).then(res => {
                if (res.status === 200) {
                    store.commit("setUser", {...store.state.user, ...val});

                    if(store.state.user.must_update_password){
                        store.commit("shared/setAlert", `<h5>Password successfully created </h5>`, {root: true})
                        store.state.user.must_update_password = false;
                        store.commit("setUser", store.state.user);
                        router.push({name: 'Home'});
                    }else{
                        store.commit("shared/setAlert", `<h5>Profile updated</h5>`, {root: true})
                    }
                }
            }).catch(function (err) {
                if (err && err.response) {
                    const error = err.response.data;
                    store.commit("shared/setAlert", `<h5>${error}</h5`, {root: true})
                } else {
                    store.commit("shared/setAlert", `<h5>Error. Please check your internet connection.</h5>`, {root: true})
                }
            });
            if (val.notifications != store.state.notificationState) {
                let data = {
                    "email": {
                        "all_emails_disabled": val.notifications
                    }
                };
                axios.put(`/auth/users/${store.state.user.member_id}/profile/notification_settings`, data).then(res => {
                    store.commit("user/setNotificationFlag", data.email.all_emails_disabled, {root: true})
                })
            }
        },
        getNotificationState(store, {callback}) {
            axios.get(`/auth/users/${store.state.user.member_id}/profile/notification_settings`).then(res => {
                store.state.notificationState = res.data.email.all_emails_disabled;
                if (callback) {
                    callback();
                }
            })
        },
        resetPassword(store, val) {
            let login = val.email;
            if (val.type) {
                login = login.replace(/[^0-9]/g, '');
                if (!val.email && login.length !== 10) {
                    store.commit("shared/setAlert", "<h5>Phone number requires 10-digit number</h5>", {root: true});
                    return false;
                }
            } else {
                if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val.email)) {
                    store.commit("shared/setAlert", `Please enter valid email address`, {root: true});
                    return false;
                }
            }
            let businessId = store.rootState.shared.businessId;

            axios.post('/unauth/users/reset', {business_id: businessId, login, method: (val.type ? 'phone' : 'email')})
                    .then(function (response) {
                        if (response.status == 200) {
                            router.push({name: 'ResetPasswordFinish', params: {type: val.type ? 'phone' : 'email'}})
                        }
                    })
                    .catch(function (error) {
                        if (error.response && error.response.status === 404) {
                            if (val.type) {
                                store.commit("shared/setAlert", `Sorry, this phone number does not exist in our database`, {root: true});
                            } else {
                                store.commit("shared/setAlert", `Sorry, this email does not exist in our database`, {root: true});
                            }
                        }
                    });
        },
        getUserOrders(store,{callback}){
            let requests = []
            requests.push(axios.get(`/auth/users/${store.state.user.member_id}/orders?per_page=100&detailed=1`))
            requests.push(axios.get(`/auth/users/${store.state.user.member_id}/orders?per_page=100`))
            axios.all(requests).then(axios.spread((...responses) => {
                let orders = responses[0].data;
                //console.log(responses)
                orders.forEach((el, index)=> orders[index] = {...el,...responses[1].data[index]} );
                if (orders && orders.length){
                    orders.forEach((el,index)=>{
                        let sum = 0;
                        el.items.map(item => {sum += parseFloat(item.item_amount)});
                        orders[index].subTotal = sum.toFixed(2);
                        orders[index].tax = parseFloat(parseFloat(orders[index].order_amount) - orders[index].subTotal).toFixed(2);
                    });
                }
                callback?.(orders);
            }));
        }
    }
}
